import React, { FC, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type TripadvisorTagProps = {
  revenue?: number;
};

const TripadvisorTag: FC<TripadvisorTagProps> = ({ revenue }) => {
  const location = useLocation();
  const [ord, setOrd] = useState<number>();
  const revenueTagSrc = `https://pubads.g.doubleclick.net/activity;xsp=${__TRIPADVISOR_REVENUE_TAG_ID__};qty=1;cost=[${revenue}];ord=[${ord}]?`;
  const tagSrc = `https://pubads.g.doubleclick.net/activity;xsp=${__TRIPADVISOR_TAG_ID__};ord=${ord}?`;

  useEffect(() => {
    setOrd(Math.floor(Math.random() * 10000000000000000));
  }, [location.pathname]);

  if (!ord || !__TRIPADVISOR_REVENUE_TAG_ID__ || !__TRIPADVISOR_TAG_ID__) {
    return null;
  }

  return (
    <img
      src={revenue ? revenueTagSrc : tagSrc}
      alt=""
      aria-hidden="true"
      style={{
        position: 'absolute',
        width: 0,
        height: 0,
        zIndex: -1,
      }}
    />
  );
};

export default TripadvisorTag;
